<template>
  <div ref="gtranslateWrapper" :key="routeName" class="gtranslate_wrapper" />
</template>

<script>
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { GOOGLE_TRANSLATE_WIDGET_LANGUAGES } from '../../../../../resources/js/constants-elections.js'
import { GOOGLE_TRANSLATE_WIDGET_URL } from '../../../../../resources/js/constants.js'

export default defineComponent({
  name: 'Translate',

  setup() {
    const route = useRoute()
    const gtranslateWrapper = ref(null)

    const routeName = computed(() => route.name)

    onMounted(async () => {
      window.gtranslateSettings = {
        default_language: GOOGLE_TRANSLATE_WIDGET_LANGUAGES[0].value,
        languages: GOOGLE_TRANSLATE_WIDGET_LANGUAGES.map((l) => l.value),
        wrapper_selector: '.gtranslate_wrapper',
        native_language_names: true,
      }

      const script = document.createElement('script')
      script.src = GOOGLE_TRANSLATE_WIDGET_URL
      script.defer = true
      document.body.appendChild(script)

      let tries = 0
      ;(function waitForTranslateWidget() {
        const wrapper = document.querySelector('#gt_float_wrapper')
        if (wrapper || tries > 1000) {
          if (wrapper) {
            const gtOptions = document.querySelector('.gt_options')
            const gtSelected = document.querySelector('.gt-current-lang')
            const langCodeElement = document.querySelector('.gt-lang-code')
            const switcherArrowElement = document.querySelector(
              '.gt_float_switcher-arrow',
            )

            langCodeElement?.classList.add('hidden-on-mobile')
            switcherArrowElement?.classList.add('hidden-on-mobile')

            const toggleVisibility = () => {
              langCodeElement?.classList.toggle('hidden-on-mobile')
              switcherArrowElement?.classList.toggle('hidden-on-mobile')
            }

            gtSelected.addEventListener('click', toggleVisibility)
            gtOptions.addEventListener('click', toggleVisibility)
          }
        } else {
          tries++
          requestAnimationFrame(waitForTranslateWidget)
        }
      })()
    })

    return {
      routeName,
      gtranslateWrapper,
    }
  },
})
</script>

<style>
.gtranslate_wrapper #gt_float_wrapper {
  bottom: 140px !important;
  right: -1px !important;
  left: auto !important;
}

.gtranslate_wrapper .gt_float_switcher {
  width: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

@media (max-width: 767px) {
  /* Hide the selected language and dropdown arrow on mobile so it doesn't interfere with important buttons (i.e., Submit Vote)! */
  .gtranslate_wrapper #gt_float_wrapper .gt-lang-code.hidden-on-mobile {
    display: none;
  }

  .gtranslate_wrapper
    #gt_float_wrapper
    .gt_float_switcher-arrow.hidden-on-mobile {
    display: none;
  }
}
</style>
